'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        editableConfirmation: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.confirmation'
        },
        editableCreate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.create'
        },
        editableDependencyCreate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.dependencyCreate'
        },
        editableDependencyDestroy: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.dependencyDestroy'
        },
        editableDragPercentComplete: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.dragPercentComplete'
        },
        editableDestroy: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.destroy'
        },
        editableMove: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.move'
        },
        editableReorder: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.reorder'
        },
        editableResize: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.resize'
        },
        editableTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'editable.template'
        },
        editableUpdate: {
            type: Boolean,
            default: undefined,
            kComposite: 'editable.update'
        }
    }
};